import React, { useEffect, useState } from 'react';
import { about5, heroVideo, arashBg, aboutBg, subMenuProjects, subMenuHome, subMenuPartners, newsBg } from '../../assets/images';
import Header from '../../Components/Header/Header';
import SubOtherHero from '../../Components/Breadcrumb/SubOtherHero/SubOtherHero';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import NewsDetailItems from './NewsDetailItems/NewsDetailItems';

const newsItems = [
  {
    id: 1,
    imgSrc: subMenuHome,
    title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
    description: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi. HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
    date: '15.04.2025',
  },
  {
    id: 2,
    imgSrc: subMenuPartners,
    title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
    description: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi. HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
    date: '12.04.2025',
  },
  {
    id: 3,
    imgSrc: subMenuProjects,
    title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
    description: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi. HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
    date: '10.04.2025',
  },
  {
      id: 4,
      imgSrc: subMenuHome,
      title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
      description: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi. HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
      date: '15.04.2025',
    },
    {
      id: 5,
      imgSrc: subMenuPartners,
      title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
      description: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi. HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
      date: '12.04.2025',
    },
    {
      id: 6,
      imgSrc: subMenuProjects,
      title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
      description: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi. HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
      date: '10.04.2025',
    },
    {
      id: 7,
      imgSrc: subMenuHome,
      title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
      description: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi. HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
      date: '15.04.2025',
    },
    {
      id: 8,
      imgSrc: subMenuPartners,
      title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
      description: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi. HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
      date: '12.04.2025',
    },
    {
      id: 9,
      imgSrc: subMenuProjects,
      title: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
      description: 'HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi. HITACHI-nin yapon nümayəndələri  A-kond MMC-ni ziyarət etdi',
      date: '10.04.2025',
    },
];

const NewsDetail = () => {


   const { t } = useTranslation();
  
        const { id } = useParams();
  
        const [singleNews, setSingleNews] = useState("")
  
        useEffect(() => {
  
  
          const filteredTour = newsItems.find(product => product.id == id);
          setSingleNews(filteredTour);
      
        }, []);

  return (
    <>
      <div
        className='bg-black/60'
        style={{
          position: 'relative',
          overflow: 'hidden',
          backgroundImage: `url(${newsBg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          width: '100%',
          height: window.innerWidth < 640 ? '250px' : '300px',
        }}
      >
        <Header />
        <SubOtherHero title="Xəbərlər" content={singleNews.title}/>

      </div>

      <NewsDetailItems/>
    </>
  );
};

export default NewsDetail;
